var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdobeCloudLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.434,
    height: 52,
    viewBox: "0 0 70.434 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15772",
    "data-name": "Group 15772",
    transform: "translate(-179 -302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15771",
    "data-name": "Group 15771",
    transform: "translate(179 302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19682",
    "data-name": "Path 19682",
    d: "M249.434,325.936v3.852a6.161,6.161,0,0,0-.289,1.029,25.719,25.719,0,0,1-19.66,22.36c-1.32.314-2.658.55-3.988.823H199.36a5,5,0,0,0-.893-.277,21.911,21.911,0,0,1-18.827-16.882c-.237-1.062-.428-2.134-.641-3.2v-3.3c.355-1.642.583-3.324,1.087-4.92A21.687,21.687,0,0,1,202.71,310a4.1,4.1,0,0,0,3.4-1.2,24.726,24.726,0,0,1,11.652-6.073c1.285-.289,2.59-.487,3.885-.727h3.577a6.024,6.024,0,0,0,1.025.289,25.754,25.754,0,0,1,22.339,19.526C248.91,323.18,249.153,324.563,249.434,325.936ZM209.963,311.8c1.282.782,2.419,1.379,3.442,2.13a1.649,1.649,0,0,0,2.1.064,14.8,14.8,0,0,1,8.274-2.08c6.736.278,11.636,3.527,14.407,9.564,2.7,5.876,1.8,11.629-2.155,16.671-4.1,5.232-9.631,7.059-16.158,5.754a15.19,15.19,0,0,1-7.917-4.419c-3.161-3.193-6.32-6.388-9.519-9.543-1.566-1.544-3.755-1.041-4.358.93a2.531,2.531,0,0,0,.991,2.667c3.291,3.257,6.619,6.478,9.863,9.782a19.154,19.154,0,0,0,13.238,5.831,21.137,21.137,0,0,0,2.751-42.183A20.749,20.749,0,0,0,209.963,311.8ZM208.4,349.053c-1.2-1.144-2.2-1.962-3.032-2.919a6.057,6.057,0,0,0-4.912-2.1,12.094,12.094,0,0,1-11.36-14.779,12.309,12.309,0,0,1,20.564-6.083c2.353,2.248,4.587,4.62,6.911,6.9a2.357,2.357,0,0,0,3.445.122,2.278,2.278,0,0,0,0-3.423c-2.635-2.68-5.246-5.393-8.025-7.919a15.462,15.462,0,0,0-9.7-4.046,17.246,17.246,0,0,0-17.237,11.152,17.439,17.439,0,0,0,5.632,19.638C195.911,349.7,201.96,349.218,208.4,349.053Z",
    transform: "translate(-179 -302)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeCloudLogo);
export default __webpack_public_path__ + "static/media/adobe-cloud-logo.4cd8e19c5fe2b6b4c2960302eb81f4cc.svg";
export { ForwardRef as ReactComponent };